import { render, staticRenderFns } from "./FreelancerWelcome.vue?vue&type=template&id=1135e6b6"
import script from "./FreelancerWelcome.vue?vue&type=script&lang=ts"
export * from "./FreelancerWelcome.vue?vue&type=script&lang=ts"
import style0 from "./FreelancerWelcome.vue?vue&type=style&index=0&id=1135e6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports